import { render, staticRenderFns } from "./FormularioDivisa.vue?vue&type=template&id=2fc1476a"
import script from "./FormularioDivisa.vue?vue&type=script&lang=js"
export * from "./FormularioDivisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports